import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useAppSelector, useAppDispatch } from "../store/hooks";
import { selectJoint, setJoint } from "../store/slices/configurationSlice";
import { JOINTS } from "../constants";
import { JointRow } from "./Menu/JointRow";

const JointPicker: React.FC<{ id?: string }> = ({ id }) => {
  const dispatch = useAppDispatch();
  const joint = useAppSelector(selectJoint);

  return (
    <Select
      value={joint.name}
      onValueChange={(name) => {
        const selectedJoint = JOINTS.find((j) => j.name === name);
        if (selectedJoint) dispatch(setJoint(selectedJoint));
      }}
    >
      <SelectTrigger id={id} className="h-11">
        <SelectValue>
          <JointRow joint={joint} />
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="max-h-80">
        {JOINTS.map((j) => (
          <SelectItem key={j.name} value={j.name} className="py-2">
            <JointRow joint={j} />
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default JointPicker;
